import { useEffect } from "react";
import { useAuth } from "@context/shared/AuthContext";
import realtimeConnection from "@services/realtime/realtimeConnection";

// Ties this tab's live channel (ADR-0051) to the sign-in: open while signed in, closed on
// sign-out, so a signed-out tab never keeps a line to the tenant hub.
export const useRealtimeSession = () => {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    realtimeConnection.start();
    return () => {
      realtimeConnection.stop();
    };
  }, [isAuthenticated]);
};
